module.exports = __webpack_public_path__ + "static/media/open_hours.43721cf9.jpg";